<template>
  <qx-card-form title="车辆信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <!-- 车牌号码 -->
      <section slot="plateNumberInfo" slot-scope="prop">
        <ChooseCar
          :isRadio="true"
          :disabled="disabled"
          v-model="prop.form.plateNumberInfo"
          @change="handleChange"
        />
      </section>
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>

<script>
// import {
//   getFileUrl,
// } from 'api';
import ChooseCar from 'components/choose/car';
export default {
  components: {
    ChooseCar,
  },
  data () {
    return {
      disabled: false,
      otherFormData: {
        vehicleCode: '',
      },
      baseForm: {
        form: [
          {
            label: '车牌号码',
            value: 'plateNumberInfo',
            default: {},
            slot: true,
          },
          {
            label: '车辆归属',
            value: 'orgName',
            type: 'input',
            placeholder: ' ',
            disabled: true,
          },
          {
            label: '车辆归属ID',
            value: 'orgId',
            type: 'input',
            placeholder: ' ',
            disabled: true,
            hide: true,
          },
          {
            label: '车辆类型',
            value: 'vehicleType',
            type: 'input',
            placeholder: ' ',
            disabled: true,
          },
          {
            label: '车辆类型',
            value: 'licenceType',
            type: 'input',
            placeholder: ' ',
            disabled: true,
            hide: true,
          },
          {
            label: '车辆性质',
            value: 'vehicleOwnerShipName',
            type: 'input',
            placeholder: ' ',
            disabled: true,
          },
          {
            label: '车辆性质',
            value: 'vehicleOwnerShip',
            type: 'input',
            placeholder: ' ',
            disabled: true,
            hide: true,
          },
          {
            label: '车辆配置',
            value: 'vehicleOrigin',
            type: 'input',
            placeholder: ' ',
            disabled: true,
            hide: true,
          },
          {
            label: '品牌名称',
            value: 'brandModelName',
            type: 'input',
            placeholder: ' ',
            disabled: true,
          },
          {
            label: '配置',
            value: 'vehicleOriginName',
            type: 'input',
            placeholder: ' ',
            disabled: true,
          },
          {
            label: '使用状态',
            value: 'vehicleState',
            type: 'input',
            placeholder: ' ',
            disabled: true,
          },
          {
            label: '行驶证注册日期',
            value: 'drivingLicenseDate',
            type: 'input',
            placeholder: ' ',
            disabled: true,
          },
        ],
        rules: {
          plateNumberInfo: [ // 车牌号码
            { required: true, message: '请输入车牌号码', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    handleChange () {
      const plateNumberInfo = this.$refs.baseForm.getVal('plateNumberInfo');
      this.otherFormData.vehicleCode = plateNumberInfo.vehicleCode;
      this.$refs.baseForm.setVal('orgName', plateNumberInfo.orgName || ' ');
      this.$refs.baseForm.setVal('orgId', plateNumberInfo.orgId || ' ');
      this.$refs.baseForm.setVal('vehicleType', plateNumberInfo.vehicleInfo || ' ');
      this.$refs.baseForm.setVal('licenceType', plateNumberInfo.licenceType || ' ');
      this.$refs.baseForm.setVal('vehicleOwnerShipName', plateNumberInfo.vehicleOwnerShipName || ' ');
      this.$refs.baseForm.setVal('vehicleOwnerShip', plateNumberInfo.vehicleOwnerShip || ' ');
      this.$refs.baseForm.setVal('brandModelName', plateNumberInfo.brandModelName || ' ');
      this.$refs.baseForm.setVal('vehicleOriginName', plateNumberInfo.vehicleOriginName || ' ');
      this.$refs.baseForm.setVal('vehicleState', plateNumberInfo.vehicleState || ' ');
      this.$refs.baseForm.setVal('vehicleOrigin', plateNumberInfo.vehicleOrigin || ' ');
      this.$refs.baseForm.setVal('drivingLicenseDate', this.formatDate(plateNumberInfo.drivingLicenseDate) || ' ');
    },
    // 统一处理数据格式
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData.drivingLicenseDate = this.formatDate(formData.drivingLicenseDate);
        formData.vehicleCode = this.otherFormData.vehicleCode;
        if (formData.plateNumberInfo) {
          formData.plateNumber = formData.plateNumberInfo.plateNumber;
        }
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async sub () {
      const formData = await this.handleSubData();
      if (formData) {
        formData.standingBookType = 1;
        formData.serviceId = -1;
        formData.vehicleCode = this.otherFormData.vehicleCode;
        delete formData.plateNumberInfo;
      }
      // console.log('base提交参数', formData);
      return formData;
    },
    async init (data = {}) {
      this.$refs.baseForm.reset();

      if (this.$route.query.type === 'detail') {
        this.disabled = true;
      } else {
        this.disabled = false;
      }

      if (data.vehicleCode) {
        this.otherFormData.vehicleCode = data.vehicleCode;
      }
      if (data.plateNumber) {
        data.plateNumberInfo = {
          plateNumber: data.plateNumber,
        };
      }
      if (data.drivingLicenseDate) {
        data.drivingLicenseDate = this.formatDate(data.drivingLicenseDate);
      }
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
